import { isAxiosError } from 'axios';
import { apiClient } from '@/axios';
import { Endpoints } from '@/enums';

interface ApiResponse<T> {
  value: T;
}

interface IAddProforma {
  oidProForma: number | undefined;
  oidLiquidacion: number;
}

export const getAddProform = async (query: IAddProforma): Promise<string> => {
  try {
    const res = await apiClient.post<ApiResponse<string>>(
      Endpoints.AgregarProforma,
      {
        oidLiquidacion: query.oidLiquidacion,
        oidProForma: query.oidProForma,
      }
    );
    return res.data.value;
  } catch (error) {
    if (isAxiosError(error)) {
      throw new Error(error.message);
    }
    throw error;
  }
};
